import { currencyFractionDigits } from './currency';

export function getCurrencyMinorMultiplier(currency: string) {
  const multiplier = currencyFractionDigits[currency];
  if (typeof multiplier === 'number') {
    return Math.max(1, multiplier);
  }

  console.error(`unknown currency: ${currency}`);
  return 2; // most currencies have 2 decimal places
}
